<template>
	<div class="animated_logo">
		<lottie
			:options="defaultOptions"
			:width="180"
			v-on:animCreated="handleAnimation"
		/>
	</div>
</template>

<script>
import Lottie from 'vue-lottie';
import * as animationData from '../../images/fpe-logo.json';

export default {
	data() {
		return {
			defaultOptions: { animationData: animationData, loop: false },
			animationSpeed: 1,
			headerScrolled: this.scrolled,
		};
	},

	props: {
		label: {
			default: 'Loading results ...',
		},
		scrolled: {},
	},

	computed: {},

	watch: {
		scrolled() {
			if(this.scrolled === true) {
				this.stop();
				this.play();
			} else {
				this.stop();
				this.play();
			}
		},
	},

	methods: {
		handleAnimation: function (anim) {
			this.anim = anim;
		},

		stop: function () {
			this.anim.stop();
		},

		play: function () {
			this.anim.play();
		},

		pause: function () {
			this.anim.pause();
		},

		onSpeedChange: function () {
			this.anim.setSpeed(this.animationSpeed);
		},
	},

	components: {
		lottie: Lottie,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.animated_logo {

}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/AnimatedLogo.vue